// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"343c4bae","342":"107a0a79","384":"bb5ca425","432":"668ebccb","509":"ec8b604a","538":"fe7b6e98","625":"b7e1fbe5","705":"303e15e6","724":"e11c9e23","875":"8cddddac"}[chunkId] + ".chunk.js";
};